import React, { useState } from "react";
import { TextArea, List, Segment, Header } from "semantic-ui-react";
import _ from "lodash";
import FullPageWrapper from "../../wrappers/FullPageWrapper";
import Wrapper, { wrapperTypes } from "../../wrappers/Wrapper";
import UiSaveButtons from "../buttons/UiSaveButtons";
import TreeViewer from "../viewers/TreeViewer";

const CopyPaste = (props) => {

  const { handleCancel, footer } = props

  const [rawData, setRawData] = useState("");
  const [parsedList, setParsedList] = useState([]);

  const handleUpdate = () => {
    props.handleUpdate(parsedList)
  }

  const handlePaste = (e) => {
    const value = e.target.value.trim();
    setRawData(value);

    let data = null;

    try {
      // 1. Try JSON
      if (value.startsWith("{") || value.startsWith("[")) {
        data = JSON.parse(value);
      }
      // 2. Try TSV/CSV (Excel or Google Sheets paste)
      else if (value.includes("\t") || value.includes(",")) {
        const rows = value
          .split("\n")
          .map((row) => row.split(/\t|,/).map((cell) => cell.trim()));

        const headers = rows[0];
        const items = rows.slice(1).map((row) =>
          _.zipObject(headers, row)
        );

        data = items;
      }
      // 3. Fallback: treat as plain text
      else {
        data = [{ value }];
      }

      setParsedList(data);
    } catch (err) {
      console.error("Parse error:", err);
      setParsedList([{ error: "Unable to parse input" }]);
    }
  };


  const content = () => <Segment>
    <Header as="h5">Paste Data Below:</Header>
    <TextArea
      placeholder="Paste your text or data here..."
      value={rawData}
      onChange={handlePaste}
      style={{ minHeight: 100, width: '100%' }}
    />
    <Header as="h5">Generated List:</Header>
    <TreeViewer data={parsedList} scNames={true} subNames={true} />
  </Segment>

  const fpw = () => <FullPageWrapper
    content={<Wrapper
      content={content()}
      footer={footer ? footer : <UiSaveButtons
        cancel={{ oc: handleCancel, icon: 'delete' }}
        save={{ caption: 'OK', oc: handleUpdate, icon: 'check' }}
      />}
      wrapperType={wrapperTypes.padded}
      css={{ container: 'app-dark-mode' }}
    />}
    handleCancel={handleCancel}
    topperCaption={'Copy Paste'}
  />

  return fpw();
};

export default CopyPaste;
